import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    settings: {},
};

const getters = {
    settings(state) {
        return deepClone(state?.settings ?? {});
    },
};

const actions = {
    getSettings({ commit }) {
        return api.get("/api/praise-wall").then(res => {
            commit("updateSettings", {
                settings: res?.data?.praiseWall ?? {},
            });
        });
    },

    create({ commit }) {
        return api.post("/api/praise-wall/", {}).then(res => {
            commit("updateSettings", {
                settings: res?.data?.praiseWall ?? {},
            });
        });
    },

    toggleActive({ commit }) {
        return api.put("/api/praise-wall/active", {}).then(res => {
            commit("updateSettings", {
                settings: res?.data?.praiseWall ?? {},
            });
        });
    },
};

const mutations = {
    updateSettings(state, { settings }) {
        state.settings = { ...settings };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
